import AnimationClip from '../AnimationClip';
import { GetAnimationClip, PlayAnimation } from '../AnimationHelper';
import Scene from '../../../Scene/Scene';
import GameObject from '../../../GameObject/GameObject';
import UITextComponent from '../../../Component/UI/Text';

interface ISpendCoinsData {
    scene: Scene;
    coins: number;
    previousCoins: number;
}

export class SpendCoins extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: ISpendCoinsData
    ): IterableIterator<number> {
        // prettier-ignore
        const text: GameObject = GameObject.findByName('world_hud_coins_value')[0];
        text.getComponent(UITextComponent).text = meta.previousCoins.toString();

        yield* PlayAnimation(
            GetAnimationClip('Counter', text, {
                startValue: meta.previousCoins,
                finalValue: meta.previousCoins - meta.coins,
            })
        );
    }
}
